// extracted by mini-css-extract-plugin
export default {"unreadNotice":"UnreadNotice_unreadNotice__HYA9v","route":"UnreadNotice_route__QelzL","action":"UnreadNotice_action__cw3cN"};